import React, {FC, PropsWithChildren} from 'react';
import {Navigate, Outlet, useLocation} from 'react-router-dom';
import {AuthContext} from '../Contexts/AuthContext';
import {UserRole} from "../GraphQL/generated/graphql";
import {buildLoginReturnPath} from "../Pages/loginPageHelpers";

type PrivateRouteGuardProps = {
    roles: UserRole[];
};

// Decide before rendering, so protected pages never flash for signed-out users.
export const PrivateRoute: FC<PropsWithChildren<PrivateRouteGuardProps>> = ({roles}) => {
    const location = useLocation();
    const {auth} = React.useContext(AuthContext);
    const isAuthorized = roles.some(role => auth?.roles?.includes(role));

    if (!isAuthorized) {
        return <Navigate to={buildLoginReturnPath(`${location.pathname}${location.search}`)} replace/>;
    }

    return <Outlet/>;
}
